import { WSSelectOption } from "@wingspanhq/fe-component-library";
import { AccountingItem } from "@wingspanhq/wingspan-api-sdk";
import sortBy from "lodash/sortBy";

/**
 * QuickBooks items as `WSSelect` options, sorted by label. The v3 counterpart of
 * `selectQuickbooksAccountOrItemOptions`. v1 labelled these with
 * `fullyQualifiedName` (the "Parent:Child" path); v3 carries only `displayName`,
 * so a nested item shows its own name rather than its full path.
 */
export const selectorAccountingItemOptions = (
  items?: AccountingItem[]
): WSSelectOption[] =>
  sortBy(
    (items || []).map(item => ({
      label: item.displayName,
      value: item.id,
      searchText: [item.displayName, item.sku].filter(Boolean).join(" ")
    })),
    option => option.label.toLocaleLowerCase()
  );
